import styled from 'styled-components';
import { tint } from 'polished';

const EsignViewFormWrapper = styled.div`
  .ant-form-item-control-input-content {
    .ant-input:not(textarea) {
      height: 48px;
      border-radius: 5px !important;
    }
  }

  .ant-upload.ant-upload-drag {
    border-radius: 5px;
    .ant-upload {
      padding: 46px 0;
    }
    .ant-upload-drag-icon {
      margin-bottom: 0;
    }
    .anticon-upload svg {
      font-size: 18px;
      color: #c7cad1;
    }
    .ant-upload-text {
      color: #c7cad1;
      font-size: 14px;
      line-height: 155%;
    }
  }

  .ant-form-item-label {
    label {
      font-weight: 500;
      font-size: 16px;
      line-height: 155%;
      color: #3e455c;
    }
  }

  .form-header {
    padding: 16px 40px;
    background: #fff;
    box-shadow: 0px 8px 16px rgba(109, 109, 109, 0.08);
    border-radius: 14px 14px 0px 0px;
    position: relative;
    z-index: 9;
    h2 {
      margin: 0;
      color: #3fb65f;
      font-weight: bold;
      font-size: 16px;
      line-height: 1.55;
      display: flex;
      align-items: center;
      justify-content: space-between;
      span {
        color: ${props => tint(0.6, props.theme.secondary)};
        font-weight: 400;
        display: inline-block;
        margin-left: 10px;
      }
      img {
        width: 40px;
        height: 40px;
        padding: 10px;
        border-radius: 10px;
        overflow: hidden;
        background: ${props => tint(0.9, props.theme.primary)};
      }
    }
  }
  .esign_form_wrapper {
    background: #fff;
    padding: 40px;
    border-radius: 0 0 14px 14px;
  }
  .esign_form_inner {
    border-radius: 5px;
    border: 1px solid ${props => tint(0.6, props.theme.orange)};
    h3 {
      padding: 16px;
      font-weight: bold;
      font-size: 14px;
      color: ${props => tint(0.1, props.theme.orange)};
      border-bottom: 1px solid ${props => tint(0.6, props.theme.orange)};
    }
    .esign_form_inner_fields {
      padding: 32px 24px 32px;
    }
  }
`;

export default EsignViewFormWrapper;
